import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Hero from '../../components/Hero';
import styles from './ProductsArchivePage.module.scss';
import ProductCardList from '../../components/ProductCardList';

const ProductsArchivePage = ({ settings = {
        hero: {},
        footer: {},
    }, hero, data = {}, type }) => {
    return (
        <div className={styles['ProductsArchivePage']}>
            <Header {...settings.header} />
            <main>
                {hero && <Hero {...hero} type="products" />}
                <div className={styles['ProductsArchivePage__Wrapper']}>
                    <ProductCardList products={data.products} type={type} />
                </div>
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

ProductsArchivePage.propTypes = {
    hero: PropTypes.object,
    footer: PropTypes.object,
    data: PropTypes.object,
};

export default basePageWrap(ProductsArchivePage);
